export default "__VITE_ASSET__CFaFNKjN__"